import { render, staticRenderFns } from "./leadDetail.vue?vue&type=template&id=0c409d16&scoped=true&"
import script from "./leadDetail.vue?vue&type=script&lang=js&"
export * from "./leadDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c409d16",
  null
  
)

export default component.exports